import React from 'react'

function StartComp({ img, title, sub }) {
  return (
    <div>
      <div className='flex items-center gap-3'>
        <div className='flex items-center justify-center min-w-[48px] h-[48px] bg-[#CCF2E14D] rounded-xl'>
          <img src={img} alt='cardimg' className="w-6 h-6 object-contain" />
        </div>
        <div>
          <p className='text-[#1A1A1B] font-bold text-[15px] mb-0.5'>{title}</p>
          <p className='text-[#808285] text-[12px]'>{sub}</p>
        </div>
      </div>
    </div>
  )
}

export default StartComp